export const NavDropdown = {
  bindings: {
    product: '<',
    subscriptions: '<',
    onClick: '&',
  },

  template: `
    <button class="nav-link dropdown-toggle btn btn-link px-0 d-flex align-items-center"
      type="button"
      data-toggle="dropdown">
      <nav-product-title
        title="$ctrl.product.name"
        first-name="$ctrl.product.author.firstName"
        last-name="$ctrl.product.author.lastName">
      <nav-product-title>
    </button>
    <div class="dropdown-menu dropdown-menu-right rounded-0">
      <button class="btn-link dropdown-item btn btn-link rounded-0"
        type="button"
        ng-repeat="subscription in $ctrl.subscriptions track by $index"
        ng-click="$ctrl.onClick({ subscription: subscription })">
        {{ subscription.title }}
        <i class="fa fa-sm fa-check text-black"
          ng-if="subscription.voomeProductId === $ctrl.product.id">
        </i>
      </button>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavDropdown.js